/* Product question */
(function ($) {
  var _options = {};

  $.fn.ProductQuestion = function (options) {
    _options = $.extend({
      productId: 0,
      nameInputFieldId: '#input-question-name',
      companyInputFieldId: '#input-company',
      telephoneInputFieldId: '#input-telephone',
      emailInputFieldId: '#input-email',
      remarkInputFieldId: '#input-remark',
      remarkInputLimit: '#input-remark-limit',
      remarkInputNum: '#input-remark-num',
      submitButtonId: '#button-question',
      emptyLabel: {
        name: 'Please enter your name.',
        question: 'Please enter your question.',
        company: 'Please enter your company.',
        telephone: 'Please enter your telephone.',
        email: 'Please enter your email.',
      }
    }, options);
    var _parent = $(this);

    var remarkNumLimit = parseInt(_parent.find(_options.remarkInputLimit).text());
    if (isNaN(remarkNumLimit)){
      remarkNumLimit = 500;
    }
    _parent.find(_options.remarkInputFieldId).on('input', function (value) {
        var remark = $(_options.remarkInputFieldId).val();
        if (remark.length > remarkNumLimit){
          $(_options.remarkInputFieldId).val(remark.substr(0,remarkNumLimit));
        }
        $(_options.remarkInputNum).text($(_options.remarkInputFieldId).val().length);
    })

    _parent.find(_options.submitButtonId).click(function () {
      var _this = $(this);

      if (_options.productId < 1) {
        return;
      }

      var name = $(_options.nameInputFieldId).val(),
          company = $(_options.companyInputFieldId).val(),
          telephone = $(_options.telephoneInputFieldId).val(),
          email = $(_options.emailInputFieldId).val(),
          remark = $(_options.remarkInputFieldId).val(),
          ifwish =  _parent.find('input[name="ifwish"]:checked').val();

      if( company == '' ) {
        layer.msg(_options.emptyLabel.company);
        _parent.find(_options.companyInputFieldId).focus();
        return;
      }


      if (name == '') {
        layer.msg(_options.emptyLabel.name);

        _parent.find(_options.nameInputFieldId).focus();

        return;
      }

      if( telephone == '' ) {
        layer.msg(_options.emptyLabel.telephone);
        _parent.find(_options.telephoneInputFieldId).focus();
        return;
      }
      if( email == '' ) {
        layer.msg(_options.emptyLabel.email);
        _parent.find(_options.emailInputFieldId).focus();
        return;
      }
      // if (question == '') {
      //   layer.msg(_options.emptyLabel.question);
      //
      //   _parent.find(_options.questionInputFieldId).focus();
      //
      //   return;
      // }

      if(!ifwish){
        layer.msg(_options.emptyLabel.ifwish);
        return;
      }

      var utmObj = {};
      if (common.getCookie('utmObj')) {
        utmObj = JSON.parse(common.getCookie('utmObj'));
      }
      var isvSource = {}, isv_name = '';
      if (common.getCookie('campaignsources')) {
        isvSource = JSON.parse(common.getCookie('campaignsources'));
        isv_name = isvSource.source;
      }
      $.ajax({
        type: 'post',
        url: window.HttpServer + '?route=product/askquestion/add',
        data:{ product_id: _options.productId, name: name, company: company, telephone: telephone, email: email, remark: remark, ifwish: ifwish,
          utm_source: utmObj.utm_source, utm_medium: utmObj.utm_medium, utm_campaign: utmObj.utm_campaign,
          utm_content: utmObj.utm_content, utm_term: utmObj.utm_term, moduleSources: window.cateData.userRecordOption.module,
          isv_name: isv_name||''},
        success: function success(result) {
          userAction.subInquiry();
          layer.closeAll();
          // layer.alert(result);
          layer.open({
            title: '提示',
            content: result
          });
          try {
            var form_position = common.getCookie('form_position');
            gio('track', 'buysubmit_product', {
              phoneNumber: common.mobileEncryption(telephone),
              eshop_Productnumber_cms: window.cateData.userRecordOption.eshop_Productnumber_cms || '',
              eshop_productname_cms: $('.data-gio-product-name').text() || '',
              action_position: form_position || '',
              ifMatchingcompanyName: window.ifMatchingcompanyName
            });
            window.selectCompanyGio(common.mobileEncryption(telephone));
            common.delCookie('form_position');

          }catch (e) {
            console.log(e);
          }
          // 数据上报接口 - 静默处理，不影响用户体验
          try {
            $.ajax({
              type: 'post',
              url: 'https://www.dellemc-solution.com/api/account/acbdt',
              data: { mobile: telephone },
              success: function() {
                // 上报成功，无需处理
              },
              error: function() {
                // 上报失败，静默处理，不影响用户
              }
            });
          } catch (e) {
            // 接口调用异常，静默处理
          }
          _parent.find(_options.companyInputFieldId).val('');
          _parent.find(_options.emailInputFieldId).val('');
          _parent.find(_options.telephoneInputFieldId).val('');
          _parent.find(_options.nameInputFieldId).val('');
          _parent.find(_options.remarkInputFieldId).val('');
          _parent.find('input[name="ifwish"]:checked').attr('checked',false);
        }
      });
    });

    return this;
  };
}(jQuery));
